import { unwrapResponse } from "../../response.js";
import { acceptJson } from "../../shared.js";
const list = async (apiUrl) => {
  return unwrapResponse(
    await fetch(`${apiUrl}/list`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
const getDetailsByCode = async (apiUrl, request) => {
  return unwrapResponse(
    await fetch(`${apiUrl}/${request.code}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
const getStoresByFilter = async (apiUrl, request) => {
  return unwrapResponse(
    await fetch(`${apiUrl}/retrieve/filter?name=${request.filter}&value=${request.value}`, {
      method: "GET",
      headers: {
        ...acceptJson
      }
    })
  );
};
export {
  getDetailsByCode,
  getStoresByFilter,
  list
};
//# sourceMappingURL=stores.js.map
